// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__18PYV","col":"styles_col__2bAYk"};